import { useCallback } from 'react'

import { useGSAP } from './useGSAP'

export type useRunnerUITransitionProps = {
  from?: 'top' | 'bottom'
  delayEnter?: number
  yPercent?: number
}

export function useRunnerUITransition(
  elementRef: React.RefObject<HTMLElement | null>,
  { from = 'top', yPercent = 100, delayEnter = 0 }: useRunnerUITransitionProps | undefined
) {
  const { gsap } = useGSAP()

  const onEnter = useCallback(() => {
    if (!elementRef.current) return
    gsap.timeline({ delay: delayEnter }).fromTo(
      elementRef.current,
      { yPercent: from === 'top' ? -yPercent : yPercent },
      {
        yPercent: 0,
        duration: 0.7,
        ease: 'back.out(1.2)',
      },
      0
    )
  }, [delayEnter, elementRef, from, gsap])

  const onExit = useCallback(() => {
    if (!elementRef.current) return
    gsap
      .timeline()
      .addLabel('start', 0)
      .fromTo(
        elementRef.current,
        { yPercent: 0 },
        {
          yPercent: from === 'top' ? -yPercent : yPercent,
          duration: 0.7,
          ease: 'power2.out',
        },
        'start'
      )
      .fromTo(elementRef.current, { opacity: 1 }, { opacity: 0, duration: 0.7, ease: 'power2.out' }, 'start')
  }, [elementRef, from, gsap, yPercent])

  return {
    onEnter,
    onExit,
    timeout: {
      enter: 700 + delayEnter * 1000,
      exit: 700,
    },
  }
}
